module.exports = __webpack_public_path__ + "img/二维码.22e57d18.jpg";